import script from "./PrepList1PDF.vue?vue&type=script&setup=true&lang=js"
export * from "./PrepList1PDF.vue?vue&type=script&setup=true&lang=js"

import "./PrepList1PDF.vue?vue&type=style&index=0&id=2dad5541&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2dad5541"]])

export default __exports__